// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b84a362","497":"73ed36c8"}[chunkId] + ".chunk.js";
};